 (function() {
  'use strict';

  // Translation helper - reads from PP_I18N set by Liquid
  var T = window.PP_I18N || {};
  function t(key, fallback) { return T[key] || fallback || key; }

  function $(selector, root) {
    return (root || document).querySelector(selector);
  }
  function $all(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  // Safe HTML sanitizer - allows only basic formatting tags
  function sanitizeHTML(html) {
    if (!html) return '';
    var temp = document.createElement('div');
    temp.innerHTML = html;
    // Only allow safe tags
    var allowedTags = ['P', 'BR', 'STRONG', 'B', 'EM', 'I', 'U', 'UL', 'OL', 'LI', 'A', 'SPAN'];
    var walker = document.createTreeWalker(temp, NodeFilter.SHOW_ELEMENT, null, false);
    var nodesToRemove = [];
    while (walker.nextNode()) {
      var node = walker.currentNode;
      if (allowedTags.indexOf(node.tagName) === -1) {
        nodesToRemove.push(node);
      } else if (node.tagName === 'A') {
        // Sanitize links - only allow http/https
        var href = node.getAttribute('href') || '';
        if (!/^https?:\/\//.test(href) && !/^\//.test(href) && !/^#/.test(href)) {
          node.removeAttribute('href');
        }
        node.setAttribute('rel', 'noopener noreferrer');
      }
      // Remove all event handlers
      var attrs = Array.prototype.slice.call(node.attributes);
      for (var i = 0; i < attrs.length; i++) {
        if (attrs[i].name.indexOf('on') === 0) {
          node.removeAttribute(attrs[i].name);
        }
      }
    }
    // Replace disallowed nodes with their text content
    for (var j = 0; j < nodesToRemove.length; j++) {
      var n = nodesToRemove[j];
      var txt = document.createTextNode(n.textContent);
      n.parentNode.replaceChild(txt, n);
    }
    return temp.innerHTML;
  }

  // Safe URL validator for video embeds
  function isValidVideoUrl(url) {
    if (!url) return false;
    // Only allow YouTube, Vimeo, and direct video files from known domains
    var patterns = [
      /^https?:\/\/(www\.)?(youtube\.com|youtu\.be)\//,
      /^https?:\/\/(www\.)?vimeo\.com\//,
      /^https?:\/\/.*\.(mp4|webm)(\?.*)?$/,
      /^https?:\/\/cdn\.shopify\.com\//
    ];
    for (var i = 0; i < patterns.length; i++) {
      if (patterns[i].test(url)) return true;
    }
    return false;
  }

  // Populate 1RM options in 2.5kg increments from 40 to 200
  function populateTMOptions(select) {
    if (!select) return;
    var frag = document.createDocumentFragment();
    var first = document.createElement('option');
    first.value = '';
    first.textContent = '-- Kies een waarde --';
    frag.appendChild(first);
    for (var v = 40; v <= 200; v += 2.5) {
      var val = Math.round(v * 10) / 10;
      var o = document.createElement('option');
      o.value = String(val);
      o.textContent = (val % 1 === 0 ? val.toFixed(0) : val.toFixed(1)) + ' kg';
      frag.appendChild(o);
    }
    select.innerHTML = '';
    select.appendChild(frag);
  }

  function roundTo(step, value) {
    var inv = 1 / step;
    return Math.round(value * inv) / inv;
  }

  function formatKg(n) {
    return (Math.round(n * 10) / 10).toFixed(n % 1 === 0 ? 0 : 1) + ' kg';
  }

  // 1RM Calculator using Epley formula: 1RM = weight × (1 + reps/30)
  function calculate1RM(weight, reps) {
    if (!weight || !reps || reps < 1) return null;
    if (reps === 1) return weight;
    return weight * (1 + reps / 30);
  }

  // Week tips for motivation and guidance (translated via PP_I18N)
  var WEEK_TIPS = {
    1: { title: t('week1_title', 'Week 1: Foundation'), tip: t('week1_tip', 'Focus on technique and building volume.') },
    2: { title: t('week2_title', 'Week 2: Volume'), tip: t('week2_tip', 'Sets are going up. Get good sleep and nutrition.') },
    3: { title: t('week3_title', 'Week 3: Peak Volume'), tip: t('week3_tip', 'The heaviest volume week! Stay focused.') },
    4: { title: t('week4_title', 'Week 4: Intensify'), tip: t('week4_tip', 'Volume drops, intensity rises.') },
    5: { title: t('week5_title', 'Week 5: Peak'), tip: t('week5_tip', 'Heavy sets, low reps. Every rep counts.') },
    6: { title: t('week6_title', 'Week 6: Taper'), tip: t('week6_tip', 'Recovery is essential now.') },
    7: { title: t('week7_title', 'Week 7'), tip: t('week7_tip', 'Go for that new PR!') }
  };

  // Exercise display labels - Bench Booster 2.0 (translated via PP_I18N)
  var EXERCISES = {
    bench_press: 'Bench Press',
    bench_press_331: '3/3/1 Bench Press',
    bench_press_heavy: t('bench_press_heavy', 'Bench Press (heavy)'),
    bench_press_backoff: t('bench_press_backoff', 'Bench Press (backoff)'),
    incline_bench: 'Incline Bench Press',
    incline_db_press: 'Incline Dumbbell Press',
    chest_flys: 'Chest Fly\'s',
    flat_db_press: 'Flat Dumbbell Press',
    machine_press: 'Machine Press<br><span class="pp-ex-sub">' + t('machine_press_sub', '(or other chest variation)') + '</span>',
    ez_skull_crushers: 'EZ-Bar Skull Crushers',
    close_grip_bench: 'Close Grip Bench Press',
    military_press: 'Military Shoulder Press',
    // Week 7 max test
    warmup_1: 'Bench Press Warm Up 1',
    warmup_2: 'Bench Press Warm Up 2',
    buildup_1: 'Bench Press Build-up 1',
    buildup_2: 'Bench Press Build-up 2',
    current_pr: t('current_pr', 'Bench Press Current PR'),
    new_pr: t('bench_pr_attempt', 'Bench PR Attempt')
  };


  // Storage helpers with error logging
  var storageAvailable = true;
  function checkStorage() {
    try {
      var test = '__pp_test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch(e) {
      storageAvailable = false;
      console.warn('Bench Booster: localStorage not available.', e.message);
      return false;
    }
  }
  checkStorage();

  function storageKey(customerId) {
    return 'pp_tm_' + (customerId || 'guest');
  }

  function readStoredTM(customerId) {
    if (!storageAvailable) return null;
    try {
      var raw = localStorage.getItem(storageKey(customerId));
      return raw ? parseFloat(raw) : null;
    } catch(e) {
      console.warn('Bench Booster: Kon TM niet lezen uit localStorage:', e.message);
      return null;
    }
  }
  function writeStoredTM(customerId, tm) {
    if (!storageAvailable) return false;
    try {
      localStorage.setItem(storageKey(customerId), String(tm));
      return true;
    } catch(e) {
      console.warn('Bench Booster: Kon TM niet opslaan in localStorage:', e.message);
      // Likely quota exceeded
      if (e.name === 'QuotaExceededError') {
        console.warn('Bench Booster: localStorage vol. Probeer je browser cache te legen.');
      }
      return false;
    }
  }

  function dateKey(customerId){ return 'pp_tm_date_' + (customerId || 'guest'); }
  function readStoredDate(customerId){
    if (!storageAvailable) return null;
    try { return localStorage.getItem(dateKey(customerId)); } catch(e){ return null; }
  }
  function writeStoredDate(customerId, dateStr){
    if (!storageAvailable) return false;
    try { localStorage.setItem(dateKey(customerId), dateStr); return true; } catch(e){ return false; }
  }

  // Parse date string - supports both DD-MM-YYYY (localStorage) and YYYY-MM-DD (Shopify metafield)
  function parseDate(dateStr) {
    if (!dateStr) return null;
    var parts = dateStr.split('-');
    if (parts.length !== 3) return null;
    // Detect format by checking if first part is 4 digits (YYYY-MM-DD)
    if (parts[0].length === 4) {
      // YYYY-MM-DD (Shopify metafield format)
      return new Date(parseInt(parts[0],10), parseInt(parts[1],10)-1, parseInt(parts[2],10));
    } else {
      // DD-MM-YYYY (localStorage format)
      return new Date(parseInt(parts[2],10), parseInt(parts[1],10)-1, parseInt(parts[0],10));
    }
  }

  // Optional: also persist as cart attribute (per session, not account-level)
  function persistCartAttribute(tm) {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { training_max_tm: tm }})
      }).catch(function(){});
    } catch(e) {}
  }

  // Bench Booster 2.0 - Week Plan from Excel
  // factor = null means self-determined weight
  // optional: true means the exercise is optional
  // rounding: 2.5 for barbell exercises, 2 for dumbbell exercises
  var WEEK_PLAN = {
    1: [
      // Day 1
      [
        { key: 'bench_press', sets: 2, reps: 8, factor: 0.667, rounding: 2.5 },
        { key: 'incline_bench', sets: 2, reps: 8, factor: 0.534, rounding: 2.5 },
        { key: 'incline_db_press', sets: 2, reps: 8, factor: 0.25, rounding: 2 },
        { key: 'chest_flys', sets: 2, reps: 10, factor: null }
      ],
      // Day 2
      [
        { key: 'bench_press_331', sets: 2, reps: 5, factor: 0.676, rounding: 2.5 },
        { key: 'flat_db_press', sets: 2, reps: 8, factor: 0.30, rounding: 2 },
        { key: 'machine_press', sets: 2, reps: 8, factor: null },
        { key: 'ez_skull_crushers', sets: 2, reps: 8, factor: 0.267, rounding: 2.5 }
      ],
      // Day 3
      [
        { key: 'bench_press', sets: 3, reps: 3, factor: 0.799, rounding: 2.5 },
        { key: 'close_grip_bench', sets: 2, reps: 5, factor: 0.676, rounding: 2.5 },
        { key: 'military_press', sets: 2, reps: 5, factor: 0.432, rounding: 2.5 }
      ]
    ],
    2: [
      // Day 1
      [
        { key: 'bench_press', sets: 3, reps: 8, factor: 0.68, rounding: 2.5 },
        { key: 'incline_bench', sets: 3, reps: 8, factor: 0.544, rounding: 2.5 },
        { key: 'incline_db_press', sets: 3, reps: 8, factor: 0.255, rounding: 2 },
        { key: 'chest_flys', sets: 2, reps: 10, factor: null }
      ],
      // Day 2
      [
        { key: 'bench_press_331', sets: 3, reps: 5, factor: 0.686, rounding: 2.5 },
        { key: 'flat_db_press', sets: 3, reps: 8, factor: 0.306, rounding: 2 },
        { key: 'machine_press', sets: 3, reps: 8, factor: null },
        { key: 'ez_skull_crushers', sets: 3, reps: 8, factor: 0.272, rounding: 2.5 }
      ],
      // Day 3
      [
        { key: 'bench_press', sets: 5, reps: 3, factor: 0.811, rounding: 2.5 },
        { key: 'close_grip_bench', sets: 3, reps: 5, factor: 0.686, rounding: 2.5 },
        { key: 'military_press', sets: 3, reps: 5, factor: 0.438, rounding: 2.5 }
      ]
    ],
    3: [
      // Day 1
      [
        { key: 'bench_press', sets: 4, reps: 8, factor: 0.707, rounding: 2.5 },
        { key: 'incline_bench', sets: 3, reps: 8, factor: 0.566, rounding: 2.5 },
        { key: 'incline_db_press', sets: 3, reps: 8, factor: 0.265, rounding: 2 },
        { key: 'chest_flys', sets: 3, reps: 10, factor: null }
      ],
      // Day 2
      [
        { key: 'bench_press_331', sets: 4, reps: 5, factor: 0.707, rounding: 2.5 },
        { key: 'flat_db_press', sets: 3, reps: 8, factor: 0.318, rounding: 2 },
        { key: 'machine_press', sets: 3, reps: 8, factor: null },
        { key: 'ez_skull_crushers', sets: 3, reps: 8, factor: 0.283, rounding: 2.5 }
      ],
      // Day 3
      [
        { key: 'bench_press', sets: 6, reps: 3, factor: 0.837, rounding: 2.5 },
        { key: 'close_grip_bench', sets: 3, reps: 5, factor: 0.707, rounding: 2.5 },
        { key: 'military_press', sets: 3, reps: 5, factor: 0.452, rounding: 2.5 }
      ]
    ],
    4: [
      // Day 1
      [
        { key: 'bench_press', sets: 5, reps: 5, factor: 0.799, rounding: 2.5 },
        { key: 'incline_bench', sets: 3, reps: 5, factor: 0.639, rounding: 2.5 }
      ],
      // Day 2
      [
        { key: 'bench_press', sets: 4, reps: 4, factor: 0.837, rounding: 2.5 },
        { key: 'close_grip_bench', sets: 2, reps: 5, factor: 0.719, rounding: 2.5 }
      ],
      // Day 3
      [
        { key: 'bench_press', sets: 5, reps: 3, factor: 0.85, rounding: 2.5 },
        { key: 'chest_flys', sets: '-', reps: '-', factor: null, optional: true }
      ]
    ],
    5: [
      // Day 1
      [
        { key: 'bench_press', sets: 5, reps: 5, factor: 0.811, rounding: 2.5 },
        { key: 'incline_bench', sets: 3, reps: 5, factor: 0.649, rounding: 2.5 }
      ],
      // Day 2
      [
        { key: 'bench_press', sets: 4, reps: 4, factor: 0.85, rounding: 2.5 },
        { key: 'close_grip_bench', sets: 2, reps: 5, factor: 0.73, rounding: 2.5 }
      ],
      // Day 3
      [
        { key: 'bench_press', sets: 3, reps: 2, factor: 0.907, rounding: 2.5 },
        { key: 'chest_flys', sets: '-', reps: '-', factor: null, optional: true }
      ]
    ],
    6: [
      // Day 1
      [
        { key: 'bench_press', sets: 3, reps: 4, factor: 0.85, rounding: 2.5 }
      ],
      // Day 2
      [
        { key: 'bench_press', sets: 4, reps: 3, factor: 0.892, rounding: 2.5 }
      ],
      // Day 3
      [
        { key: 'bench_press_heavy', sets: 2, reps: 1, factor: 0.978, rounding: 2.5 },
        { key: 'bench_press_backoff', sets: 1, reps: 3, factor: 0.907, rounding: 2.5 }
      ]
    ],
    7: [
      // Max Test Day (only one "day" - the max attempt)
      [
        { key: 'warmup_1', sets: 2, reps: 8, factor: 0.424, rounding: 2.5 },
        { key: 'warmup_2', sets: 2, reps: 5, factor: 0.667, rounding: 2.5 },
        { key: 'buildup_1', sets: 1, reps: 3, factor: 0.788, rounding: 2.5 },
        { key: 'buildup_2', sets: 1, reps: 1, factor: 0.909, rounding: 2.5 },
        { key: 'current_pr', sets: 1, reps: 1, factor: 1.0, rounding: 2.5 },
        { key: 'new_pr', sets: 1, reps: 1, factor: null, maximal: true }
      ]
    ]
  };

  function getWeekPlan(week) {
    return WEEK_PLAN[week] || [[],[],[]];
  }

  function buildDayTable(exercises, tm, showHeader, appRoot) {
    var table = '<table class="table pp-center" role="table">';
    table += '<colgroup><col style="width:42%"><col style="width:28%"><col style="width:30%"></colgroup>';
    if (showHeader) {
      table += '<thead><tr>' +
               '<th>' + t('exercise', 'Exercise') + '</th><th>' + t('sets_x_reps', 'Sets × Reps') + '</th><th>' + t('weight', 'Weight') + '</th>' +
               '</tr></thead>';
    }
    table += '<tbody>';
    exercises.forEach(function(ex) {
      var p = (typeof ex.factor === 'number') ? ex.factor : null;
      var cell = '—';

      // Handle weight calculation
      if (p !== null && isFinite(tm)) {
        var weight = tm * p;
        var step = ex.rounding || 2.5; // Custom rounding per exercise
        var rounded = roundTo(step, weight);
        cell = formatKg(rounded);
      } else if (ex.factor === null) {
        cell = ex.maximal
          ? '<span class="pp-self-weight">' + t('maximal', 'Maximal') + '</span>'
          : '<span class="pp-self-weight">' + t('self_determine', 'Self Determine') + '</span>';
      }

      // Handle sets and reps
      var sets = ex.sets;
      var reps = ex.reps;
      var setsReps;
      if (sets === '-' || reps === '-') {
        setsReps = '-';
      } else {
        setsReps = sets + ' × ' + reps;
      }

      // Build exercise label
      var label = ex.name || (EXERCISES[ex.key] || ex.key || '-');
      if (ex.optional) {
        label = '<span class="pp-optional">' + t('optional', '(Optional)') + '</span> ' + label;
      }

      var key = ex.key || null;
      var videoUrl = '';
      if (key) {
        videoUrl = appRoot.getAttribute('data-video-' + key) || '';
        if (!videoUrl) {
          var allApps = document.querySelectorAll('.powerlifting-program__app');
          for (var vi = 0; vi < allApps.length; vi++) {
            videoUrl = allApps[vi].getAttribute('data-video-' + key) || '';
            if (videoUrl) break;
          }
        }
      }
      var nameCell = label;
      if (videoUrl) {
        var safeUrl = videoUrl.replace(/"/g,'&quot;');
        var safeName = String(label).replace(/"/g,'&quot;');
        nameCell = '<span class="pp-ex-name">' + label + ' <button class="pp-ex-info" title="' + t('view_video', 'View video') + '" aria-label="' + t('view_video', 'View video') + '" data-video-url="' + safeUrl + '" data-ex-name="' + safeName + '">' +
                   '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M10 16.5l6-4.5-6-4.5v9z"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 s10-4.48 10-10S17.52 2 12 2zM12 20c-4.41 0-8-3.59-8-8 s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></svg>'+
                   '</button></span>';
      }

      // Add note if present (e.g., for new PR exercise)
      if (ex.note) {
        nameCell += '<div class="pp-ex-note">' + ex.note + '</div>';
      }

      table += '<tr' + (ex.optional ? ' class="pp-row-optional"' : '') + '>' +
               '<td>' + nameCell + '</td>' +
               '<td>' + setsReps + '</td>' +
               '<td>' + cell + '</td>' +
               '</tr>';
    });
    table += '</tbody></table>';
    return table;
  }

  function renderProgram(container, opts) {
    var start = Number(container.getAttribute('data-start-week')) || 1;
    var end = Number(container.getAttribute('data-end-week')) || 7;
    var showHeader = String(container.getAttribute('data-show-header')) !== 'false';
    var logoUrl = container.getAttribute('data-logo-url') || '';
    var customerId = container.getAttribute('data-customer-id') || null;
    var metafieldDate = container.getAttribute('data-start-date') || null;
    var localDate = readStoredDate(customerId);
    // Prefer metafield when it differs (updated externally)
    var startDateStr = (metafieldDate && localDate && metafieldDate !== localDate) ? metafieldDate : (localDate || metafieldDate || null);

    // Calculate which week we're in based on start date
    var currentWeekNum = 1;
    if (startDateStr) {
      var startDate = parseDate(startDateStr);
      if (startDate) {
        var daysSinceStart = Math.floor((Date.now() - startDate.getTime()) / (1000*60*60*24));
        currentWeekNum = Math.floor(daysSinceStart / 7) + 1;
      }
    }

    var tm = opts.tm;
    var out = '';

    for (var w=start; w<=end; w++) {
      var days = getWeekPlan(w);
      var weekTip = WEEK_TIPS[w] || {};
      var numDays = days.length; // Dynamic number of days per week

      // Week container
      out += '<div class="pp-week-group" data-week="' + w + '">';

      // Week tip (always visible - provides useful context)
      if (weekTip.tip) {
        out += '<div class="pp-week-tip">' +
                 '<strong>' + (weekTip.title || 'Tip') + ':</strong> ' + weekTip.tip +
               '</div>';
      }

      // Days - dynamic based on week plan
      for (var d=1; d<=numDays; d++) {
        var exs = days[d-1] || [];

        // Special label for Week 7 (Max Test)
        var dayLabel = (numDays === 1)
          ? t('week_label', 'Week __WEEK__').replace('__WEEK__', w)
          : t('week_day_label', 'Week __WEEK__ – Day __DAY__').replace('__WEEK__', w).replace('__DAY__', d);

        // Build logo HTML if available
        var logoHtml = logoUrl ? '<img src="' + logoUrl + '" alt="" class="pp-header-logo" width="24" height="24">' : '';

        // Collapse icon for clickable header
        var collapseIcon = '<svg class="pp-collapse-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg>';

        // Determine if week is completed (past) or current
        var isCompleted = (w < currentWeekNum);
        var isCollapsed = isCompleted;
        var collapsedClass = isCollapsed ? ' pp-week--collapsed' : '';
        var completedClass = isCompleted ? ' pp-week--completed' : '';
        var completedBadge = isCompleted ? '<span class="pp-completed-badge"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg></span>' : '';

        // Use unique ID for each week element for reliable toggle
        var weekId = 'pp-week-' + w + '-' + d + '-' + Math.random().toString(36).substr(2, 9);

        out += '<div id="' + weekId + '" class="pp-week cn-table pp-week--collapsible' + (w === 7 ? ' pp-week--max' : '') + collapsedClass + completedClass + '" data-week-num="' + w + '" data-day-num="' + d + '">' +
                 '<div class="gold-frame">' +
                   '<div class="card_samenstelling">' +
                     '<div class="header" onclick="(function(e){e.stopPropagation();var w=document.getElementById(\'' + weekId + '\');if(w)w.classList.toggle(\'pp-week--collapsed\');})(event)">' +
                       '<div class="title-wrap pp-title-with-logo">' +
                         logoHtml +
                         '<h3 class="title gold-text">' + dayLabel + '</h3>' +
                         completedBadge +
                         collapseIcon +
                       '</div>' +
                     '</div>' +
                     '<div class="pp-week-content">' +
                       buildDayTable(exs, tm, showHeader, container) +
                     '</div>' +
                   '</div>' +
                 '</div>' +
               '</div>';
      }

      out += '</div>'; // .pp-week-group
    }

    opts.output.innerHTML = out;
    opts.output.classList.remove('pp-appear');
    setTimeout(function(){ opts.output.classList.add('pp-appear'); }, 0);
    // Note: Click handlers for collapsible weeks are inline onclick in the HTML for maximum reliability
  }

  function initInstance(root) {
    if (root.getAttribute('data-pp-initialized') === 'true') return;
    root.setAttribute('data-pp-initialized', 'true');
    var customerId = root.getAttribute('data-customer-id') || null;
    var customerEmail = root.getAttribute('data-customer-email') || null;
    var select = $('#pp-tm', root) || $('#pp-tm-embed', root);
    var button = $('#pp-generate', root) || $('#pp-generate-embed', root);
    var output = $('#pp-output', root) || $('#pp-output-embed', root);
    if (select) populateTMOptions(select);

    // Find section title and outer wrapper for hiding/showing when locked
    var sectionTitle = null;
    var parentInner = root.closest('.powerlifting-program__inner');
    if (parentInner) sectionTitle = parentInner.querySelector('.powerlifting-program__title');
    var sectionWrapper = root.closest('.powerlifting-program');

    // ============ REGISTER EVENT LISTENERS FIRST (before any early returns) ============
    // This ensures ALL blocks respond to pp:started and pp:reset events

    // React to global reset
    window.addEventListener('pp:reset', function(){
      var sw = Number(root.getAttribute('data-start-week')) || 1;
      if (output) output.innerHTML = '';
      // Remove any existing note
      var existingNote = root.querySelector('.pp-output-note');
      if (existingNote) existingNote.remove();

      if (sw === 1) {
        // First block: show controls & start prompt
        $all('.powerlifting-program__controls', root).forEach(function(el){ el.style.display = ''; });
        root.style.display = '';
        if (sectionTitle) sectionTitle.style.display = '';
      } else {
        // Later blocks: hide entirely until new schema starts
        $all('.powerlifting-program__controls', root).forEach(function(el){ el.style.display = 'none'; });
        root.style.display = 'none';
        if (sectionTitle) sectionTitle.style.display = 'none';
      }
    });

    // React to schema started
    window.addEventListener('pp:started', function(){
      var sw = Number(root.getAttribute('data-start-week')) || 1;
      var md = Number(root.getAttribute('data-min-days')) || 0;
      var cid = root.getAttribute('data-customer-id') || null;
      var td = readStoredDate(cid) || root.getAttribute('data-start-date') || null;
      var currentTm = readStoredTM(cid) || parseFloat(root.getAttribute('data-training-max')) || null;

      // Hide controls for all blocks when schema is started
      $all('.powerlifting-program__controls', root).forEach(function(el){ el.style.display = 'none'; });

      // If no start date, hide block (shouldn't happen after pp:started)
      if (!td) {
        root.style.display = 'none';
        if (sectionTitle) sectionTitle.style.display = 'none';
        return;
      }

      // Check time gating
      if (md > 0) {
        var allow = false;
        var d0 = parseDate(td);
        if (d0) {
          var diff = Math.floor((Date.now() - d0.getTime())/(1000*60*60*24));
          if (diff >= md) allow = true;
        }
        if (!allow) {
          // Show locked card only once (first future block)
          if (!window.__ppLockedShown) {
            window.__ppLockedShown = true;
            if (output) output.innerHTML = buildLockedCardInternal(td, md, sw);
            root.style.display = '';
            if (sectionWrapper) sectionWrapper.style.display = '';
            if (sectionTitle) sectionTitle.style.display = 'none';
          } else {
            root.style.display = 'none';
            if (sectionWrapper) sectionWrapper.style.display = 'none';
            if (sectionTitle) sectionTitle.style.display = 'none';
          }
          return;
        }
      }

      // Gating passed or no gating - show and render
      root.style.display = '';
      if (sectionWrapper) sectionWrapper.style.display = '';
      if (sectionTitle) sectionTitle.style.display = '';
      if (currentTm && output && !output.querySelector('.pp-week')) {
        renderProgram(root, { tm: currentTm, output: output });
      }
    });

    // ============ END EVENT LISTENERS ============

    var initialTm = parseFloat(root.getAttribute('data-training-max'));
    if (!isFinite(initialTm)) initialTm = null;
    var initialDate = root.getAttribute('data-start-date') || null;

    // Metafield (Shopify) is source of truth; sync localStorage if metafield differs
    var stored = readStoredTM(customerId);
    var tm;
    if (initialTm && stored && initialTm !== stored) {
      // Metafield was updated externally (e.g. Shopify admin) — prefer metafield
      tm = initialTm;
      writeStoredTM(customerId, initialTm);
    } else {
      tm = stored || initialTm || null;
    }
    var storedDate = readStoredDate(customerId);
    var tmDate;
    if (initialDate && storedDate && initialDate !== storedDate) {
      // Metafield date updated externally — prefer metafield
      tmDate = initialDate;
      writeStoredDate(customerId, initialDate);
    } else {
      tmDate = storedDate || initialDate || null;
    }
    var startWeek = Number(root.getAttribute('data-start-week')) || 1;
    var minDays = Number(root.getAttribute('data-min-days')) || 0;

    if (tm && select) {
      // set select to matching value if exists
      var found = false;
      $all('option', select).forEach(function(opt) {
        if (parseFloat(opt.value) === tm) { opt.selected = true; found = true; }
      });
      if (!found) {
        // if custom TM, append hidden option to show it
        var opt = document.createElement('option');
        opt.value = String(tm);
        opt.textContent = formatKg(tm);
        opt.selected = true;
        select.appendChild(opt);
      }
    }

    function ensureTmSelected() {
      var val = select ? parseFloat(select.value) : tm;
      return isFinite(val) ? val : null;
    }

    // Reset handler with loading state
    function handleReset(noteEl) {
      showConfirmReset(function(){
        // Show loading state
        if (output) output.innerHTML = '<div class="pp-loading"><div class="pp-spinner"></div><p style="margin-top:8px;color:#666;">' + t('schema_resetting', 'Resetting program...') + '</p></div>';

        // Clear local storage immediately
        writeStoredTM(customerId, '');
        writeStoredDate(customerId, '');

        // Send reset to n8n
        saveCustomerTM('Reset', customerEmail, null, null);

        // Small delay to allow n8n processing, then update UI
        setTimeout(function(){
          try { window.__ppLockedShown = false; } catch(_) {}
          try { window.dispatchEvent(new CustomEvent('pp:reset')); } catch(_) {}
          $all('.powerlifting-program__controls', root).forEach(function(el){ el.style.display = ''; });
          if (select) { select.value = ''; select.focus(); }
          if (output) output.innerHTML = '';
          if (noteEl && noteEl.parentNode) noteEl.parentNode.removeChild(noteEl);
        }, 500);
      });
    }

    function onGenerate() {
      var cur = ensureTmSelected();
      if (!isFinite(cur) || cur < 40) {
        output.innerHTML = '<p class="pp-subtle">' + t('select_1rm_first', 'Select your 1RM first to generate the program.') + '</p>';
        if (select) select.focus();
        return;
      }
      showConfirmStart(cur, function(){
        if (output) output.innerHTML = '<div class="pp-loading"><div class="pp-spinner"></div></div>';
        writeStoredTM(customerId, cur);
        persistCartAttribute(cur);
        var d = new Date();
        var dateStr = ('0'+d.getDate()).slice(-2) + '-' + ('0'+(d.getMonth()+1)).slice(-2) + '-' + d.getFullYear();
        writeStoredDate(customerId, dateStr);
        saveCustomerTM('Created', customerEmail, cur, dateStr);

        // Hide controls immediately after schema is generated
        $all('.powerlifting-program__controls', root).forEach(function(el){ el.style.display = 'none'; });

        // Add the "Schema gestart" note with reset link
        var existingNote = root.querySelector('.pp-output-note');
        if (!existingNote && output) {
          var note = document.createElement('div');
          note.className = 'pp-output-note';
          var info = t('schema_started_on', 'Program started on __DATE__ (1RM: __WEIGHT__)').replace('__DATE__', dateStr).replace('__WEIGHT__', formatKg(cur));
          note.innerHTML = info + ' – <a href="#" class="pp-reset">' + t('new_schema', 'Start new program') + '</a>';
          output.before(note);
          note.addEventListener('click', function(e){
            var a = e.target.closest('.pp-reset'); if (!a) return; e.preventDefault();
            handleReset(note);
          });
        }

        // Broadcast event and render after a small delay for n8n
        setTimeout(function(){
          try { window.__ppLockedShown = false; window.dispatchEvent(new CustomEvent('pp:started')); } catch(_) {}
          renderProgram(root, { tm: cur, output: output });
        }, 300);
      });
    }

    if (button) button.addEventListener('click', onGenerate);

    // Tab switching for calculator
    (function setupTabs(){
      var tabs = $all('.pp-tab', root);
      var contents = $all('.pp-tab-content', root);
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var targetTab = tab.getAttribute('data-tab');
          tabs.forEach(function(t) { t.classList.remove('pp-tab--active'); });
          contents.forEach(function(c) { c.classList.remove('pp-tab-content--active'); });
          tab.classList.add('pp-tab--active');
          var targetContent = root.querySelector('[data-tab-content="' + targetTab + '"]');
          if (targetContent) targetContent.classList.add('pp-tab-content--active');
        });
      });
    })();

    // 1RM Calculator
    (function setup1RMCalculator(){
      var weightSelect = $('#pp-calc-weight', root);
      var repsSelect = $('#pp-calc-reps', root);
      var outputEl = $('#pp-calc-output', root);
      var useBtn = $('#pp-calc-use', root);

      if (!weightSelect || !repsSelect || !outputEl) return;

      // Populate weight options: 20-150 kg in 2.5kg steps
      (function populateWeightOptions() {
        var frag = document.createDocumentFragment();
        var first = document.createElement('option');
        first.value = '';
        first.textContent = t('choose_weight', '-- Choose weight --');
        frag.appendChild(first);
        for (var w = 20; w <= 150; w += 2.5) {
          var val = Math.round(w * 10) / 10;
          var o = document.createElement('option');
          o.value = String(val);
          o.textContent = (val % 1 === 0 ? val.toFixed(0) : val.toFixed(1)) + ' kg';
          frag.appendChild(o);
        }
        weightSelect.innerHTML = '';
        weightSelect.appendChild(frag);
      })();

      // Populate reps options: 2-12 (1 rep = already your 1RM)
      (function populateRepsOptions() {
        var frag = document.createDocumentFragment();
        var first = document.createElement('option');
        first.value = '';
        first.textContent = t('choose_reps', '-- Choose reps --');
        frag.appendChild(first);
        for (var r = 2; r <= 12; r++) {
          var o = document.createElement('option');
          o.value = String(r);
          o.textContent = t('x_reps', '__COUNT__ reps').replace('__COUNT__', r);
          frag.appendChild(o);
        }
        repsSelect.innerHTML = '';
        repsSelect.appendChild(frag);
      })();

      function updateCalc() {
        var weight = parseFloat(weightSelect.value);
        var reps = parseInt(repsSelect.value, 10);
        var result = calculate1RM(weight, reps);

        if (result && isFinite(result)) {
          var rounded = roundTo(2.5, result);
          outputEl.textContent = formatKg(rounded);
          outputEl.classList.add('pp-calc-output--active');
          if (useBtn) {
            useBtn.disabled = false;
            useBtn.setAttribute('data-calculated-tm', rounded);
          }
        } else {
          outputEl.textContent = '-- kg';
          outputEl.classList.remove('pp-calc-output--active');
          if (useBtn) useBtn.disabled = true;
        }
      }

      weightSelect.addEventListener('change', updateCalc);
      repsSelect.addEventListener('change', updateCalc);

      if (useBtn) {
        useBtn.addEventListener('click', function() {
          var calcTm = parseFloat(useBtn.getAttribute('data-calculated-tm'));
          if (isFinite(calcTm) && select) {
            // Find or create matching option
            var found = false;
            $all('option', select).forEach(function(opt) {
              if (parseFloat(opt.value) === calcTm) { opt.selected = true; found = true; }
            });
            if (!found) {
              var opt = document.createElement('option');
              opt.value = String(calcTm);
              opt.textContent = formatKg(calcTm);
              opt.selected = true;
              select.appendChild(opt);
            }
            // Switch to select tab
            var selectTab = root.querySelector('[data-tab="select"]');
            if (selectTab) selectTab.click();
          }
        });
      }
    })();

    // Enforce login: only first block (start week 1) shows login prompt; others hidden
    if (!customerId) {
      if (select) select.disabled = true;
      if (button) button.disabled = true;
      if (startWeek === 1) {
        // Hide controls and inject login card (or keep server-rendered one)
        $all('.powerlifting-program__controls', root).forEach(function(el){ el.style.display = 'none'; });
        if (!root.querySelector('.pp-login-card') && output) {
          var returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
          var loginHtml = ''+
            '<div class="pp-login-card cn-table">' +
              '<div class="gold-frame">' +
                '<div class="card_samenstelling">' +
                  '<div class="header"><div class="title-wrap"><h3 class="title">' + t('login_title', 'Login') + '</h3></div></div>' +
                  '<div class="pp-login-body">' +
                    '<p>' + t('login_text', 'Log in (or create an account) to start your personal Bench Booster V2!') + '</p>' +
                    '<div class="pp-login-actions">' +
                      '<a class="btn btn--solid btn--md" href="/account/login?return_url=' + returnUrl + '">' + t('login', 'Log in') + '</a>' +
                      '<a class="btn btn--outline" href="/account/register?return_url=' + returnUrl + '">' + t('create_account', 'Create account') + '</a>' +
                    '</div>' +
                    '<div class="pp-login-links" style="margin-top:8px;"><a href="/account/recover">' + t('forgot_password', 'Forgot password?') + '</a></div>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>';
          output.innerHTML = loginHtml;
        }
      } else {
        // hide later blocks entirely for logged-out users (including title)
        root.style.display = 'none';
        if (sectionTitle) sectionTitle.style.display = 'none';
      }
      return; // stop further rendering when logged out
    }

    // Gate this block by minDays since start date (if provided)
    if (minDays > 0) {
      // If schema not started yet (no date), hide this block entirely (including title)
      if (!tmDate) {
        root.style.display = 'none';
        if (sectionWrapper) sectionWrapper.style.display = 'none';
        if (sectionTitle) sectionTitle.style.display = 'none';
        return;
      }
      var allow = false;
      var d0 = parseDate(tmDate);
      if (d0) {
        var diff = Math.floor((Date.now() - d0.getTime()) / (1000*60*60*24));
        if (diff >= minDays) allow = true;
      }
      if (!allow) {
        // Hide controls
        $all('.powerlifting-program__controls', root).forEach(function(el){ el.style.display = 'none'; });
        // Only show ONE locked placeholder on the page (first future block)
        if (!window.__ppLockedShown) {
          window.__ppLockedShown = true;
          root.style.display = '';
          if (sectionWrapper) sectionWrapper.style.display = '';
          if (output) {
            var card = buildLockedCardInternal(tmDate, minDays, startWeek);
            output.innerHTML = card;
          }
          // Hide section title when showing locked card
          if (sectionTitle) sectionTitle.style.display = 'none';
        } else {
          root.style.display = 'none';
          if (sectionWrapper) sectionWrapper.style.display = 'none';
          if (sectionTitle) sectionTitle.style.display = 'none';
        }
        return;
      }
    }

    // Gating passed - ensure section is visible
    root.style.display = '';
    if (sectionWrapper) sectionWrapper.style.display = '';

    // Apply responsive button sizes (desktop/mobile)
    (function applyResponsiveButtonSize(){
      if (!button) return;
      var d = root.getAttribute('data-btn-size-d') || 'sm';
      var m = root.getAttribute('data-btn-size-m') || d;
      function setSize() {
        // remove previous
        ['sm','md','lg'].forEach(function(sz){ button.classList.remove('btn--'+sz); });
        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var cur = isMobile ? m : d;
        button.classList.add('btn--'+cur);
        // reflect on root for select sizing harmony
        root.setAttribute('data-pp-btn-size', cur);
      }
      setSize();
      window.addEventListener('resize', setSize);
    })();

    // Video popup handler
    (function setupVideoPopup(){
      var modalId = 'pp-video-modal';
      function ensureModal(){
        var el = document.getElementById(modalId);
        if (el) return el;
        var wrap = document.createElement('div');
        wrap.id = modalId;
        wrap.className = 'pp-modal hidden';
        wrap.innerHTML = '<div class="pp-modal__backdrop"></div>'+
                         '<div class="pp-modal__dialog cn-table">'+
                           '<div class="gold-frame">'+
                             '<div class="card_samenstelling">'+
                               '<div class="pp-modal__header">'+
                                 '<div class="pp-modal__title"></div>'+
                                 '<button class="pp-modal__close" aria-label="' + t('close', 'Close') + '">×</button>'+
                               '</div>'+
                               '<div class="pp-modal__content"></div>'+
                             '</div>'+
                           '</div>'+
                         '</div>';
        document.body.appendChild(wrap);
        wrap.querySelector('.pp-modal__backdrop').addEventListener('click', hide);
        wrap.querySelector('.pp-modal__close').addEventListener('click', hide);
        return wrap;
      }
      function toEmbed(url){
        if (!url) return '';
        // Basic YouTube convert
        var m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]+)/);
        if (m) return 'https://www.youtube.com/embed/' + m[1] + '?rel=0&autoplay=1';
        return url; // assume direct mp4 or embeddable
      }
      function show(url, title){
        var modal = ensureModal();
        var content = modal.querySelector('.pp-modal__content');
        var titleEl = modal.querySelector('.pp-modal__title');
        var embed = toEmbed(url);
        if (!embed || !isValidVideoUrl(embed)) {
          console.warn('Bench Booster: Invalid video URL blocked:', url);
          return;
        }
        titleEl.textContent = title || '';
        var html;
        if (/youtube\.com|youtu\.be/.test(embed)) {
          html = '<div class="pp-video-wrap"><iframe src="' + embed + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>';
        } else if (/\.mp4($|\?)/.test(embed)) {
          html = '<video controls autoplay src="' + embed + '"></video>';
        } else {
          html = '<iframe src="' + embed + '" frameborder="0" allowfullscreen></iframe>';
        }
        content.innerHTML = html;
        modal.classList.remove('hidden');
        document.body.classList.add('pp-modal-open');
      }
      function hide(){
        var modal = document.getElementById(modalId);
        if (!modal) return;
        modal.classList.add('hidden');
        var c = modal.querySelector('.pp-modal__content');
        if (c) c.innerHTML = '';
        document.body.classList.remove('pp-modal-open');
      }
      root.addEventListener('click', function(e){
        var b = e.target.closest('.pp-ex-info');
        if (!b) return;
        e.preventDefault();
        var url = b.getAttribute('data-video-url');
        var name = b.getAttribute('data-ex-name') || '';
        if (url) show(url, name);
      });
    })();

    // Confirm reset modal (simple)
    function showConfirmReset(onYes){
      var id = 'pp-confirm-modal';
      var el = document.getElementById(id);
      if (!el) {
        el = document.createElement('div');
        el.id = id;
        el.className = 'pp-modal hidden';
        el.innerHTML = '<div class="pp-modal__backdrop"></div>'+
                       '<div class="pp-modal__dialog cn-table">'+
                         '<div class="gold-frame">'+
                           '<div class="card_samenstelling">'+
                             '<div class="pp-modal__header">'+
                               '<div class="pp-modal__title">' + t('confirm', 'Confirm') + '</div>'+
                               '<button class="pp-modal__close" aria-label="' + t('close', 'Close') + '">×</button>'+
                             '</div>'+
                             '<div class="pp-modal__content">'+
                               '<p>' + t('confirm_reset_text', 'Are you sure? You will reset your progress.') + '</p>'+
                               '<div style="display:flex; gap:8px; justify-content:center; padding-top:8px;">'+
                                 '<button class="btn btn--solid btn--md pp-confirm-yes">' + t('yes_reset', 'Yes, reset') + '</button>'+
                                 '<button class="btn btn--outline pp-confirm-no">' + t('cancel', 'Cancel') + '</button>'+
                               '</div>'+
                             '</div>'+
                           '</div>'+
                         '</div>'+
                       '</div>';
        document.body.appendChild(el);
        el.querySelector('.pp-modal__backdrop').addEventListener('click', hide);
        el.querySelector('.pp-modal__close').addEventListener('click', hide);
        el.querySelector('.pp-confirm-no').addEventListener('click', function(){ hide(); });
        el.querySelector('.pp-confirm-yes').addEventListener('click', function(){ try{ onYes && onYes(); } finally { hide(); } });
      }
      function hide(){ el.classList.add('hidden'); document.body.classList.remove('pp-modal-open'); }
      el.classList.remove('hidden');
      document.body.classList.add('pp-modal-open');
    }

    // Confirm start modal
    function showConfirmStart(weight, onYes){
      var id = 'pp-start-modal';
      var el = document.getElementById(id);
      if (!el) {
        el = document.createElement('div');
        el.id = id;
        el.className = 'pp-modal hidden';
        el.innerHTML = '<div class="pp-modal__backdrop"></div>'+
                       '<div class="pp-modal__dialog cn-table">'+
                         '<div class="gold-frame">'+
                           '<div class="card_samenstelling">'+
                             '<div class="pp-modal__header">'+
                               '<div class="pp-modal__title">' + t('start_schema', 'Start program') + '</div>'+
                               '<button class="pp-modal__close" aria-label="' + t('close', 'Close') + '">×</button>'+
                             '</div>'+
                             '<div class="pp-modal__content">'+
                               '<p>' + t('confirm_start_text', 'Do you want to start the Bench Booster V2 based on a one-rep max of __WEIGHT__?').replace('__WEIGHT__', '<strong>' + formatKg(weight) + '</strong>') + '</p>'+
                               '<div style="display:flex; gap:8px; justify-content:center; padding-top:8px;">'+
                                 '<button class="btn btn--solid btn--md pp-start-yes">' + t('yes_start', 'Yes, start') + '</button>'+
                                 '<button class="btn btn--outline pp-start-no">' + t('cancel', 'Cancel') + '</button>'+
                               '</div>'+
                             '</div>'+
                           '</div>'+
                         '</div>'+
                       '</div>';
        document.body.appendChild(el);
        el.querySelector('.pp-modal__backdrop').addEventListener('click', hideStart);
        el.querySelector('.pp-modal__close').addEventListener('click', hideStart);
        el.addEventListener('click', function(e){
          if (e.target.closest('.pp-start-no')) { hideStart(); }
          if (e.target.closest('.pp-start-yes')) { try { onYes && onYes(); } finally { hideStart(); } }
        });
      }
      function hideStart(){ el.classList.add('hidden'); document.body.classList.remove('pp-modal-open'); }
      el.classList.remove('hidden');
      document.body.classList.add('pp-modal-open');
    }

    // Auto-generate if we already have a TM
    if (tm) {
      // Hide controls when a schema already exists
      $all('.powerlifting-program__controls', root).forEach(function(el){ el.style.display = 'none'; });
      // Show schema info/reset only on first block (start week 1)
      if (startWeek === 1) {
        var note = document.createElement('div');
        note.className = 'pp-output-note';
        var info;
        if (tmDate) {
          info = t('schema_started_on', 'Program started on __DATE__ (1RM: __WEIGHT__)').replace('__DATE__', tmDate).replace('__WEIGHT__', tm ? formatKg(tm) : '-');
        } else {
          info = t('schema_started', 'Program started');
          if (tm) info += ' (1RM: ' + formatKg(tm) + ')';
        }
        note.innerHTML = info + ' – <a href="#" class="pp-reset">' + t('new_schema', 'Start new program') + '</a>';
        if (output) output.before(note);
        note.addEventListener('click', function(e){
          var a = e.target.closest('.pp-reset'); if (!a) return; e.preventDefault();
          handleReset(note);
        });
      }
      renderProgram(root, { tm: tm, output: output });
    }
    else {
      // No schema yet
      if (startWeek === 1) {
        // First block: show the start form
        root.style.display = '';
        if (sectionTitle) sectionTitle.style.display = '';
      } else {
        // Later blocks: hide until schema is started
        root.style.display = 'none';
        if (sectionTitle) sectionTitle.style.display = 'none';
      }
    }
  }

  function initLoginForms() {
    // Login uses redirect links to Shopify's native login page (with return_url back to this page)
  }

  function init() {
    $all('.powerlifting-program__app').forEach(initInstance);
    $all('.pp-addon-app').forEach(initAddonInstance);
    initLoginForms();
    // Note: Collapsible week toggles use inline onclick handlers for maximum reliability
  }

  // parseDate - supports DD-MM-YYYY (localStorage) and YYYY-MM-DD (Shopify metafield)
  function parseDateInternal(dateStr) {
    if (!dateStr) return null;
    var parts = dateStr.split('-');
    if (parts.length !== 3) return null;
    if (parts[0].length === 4) {
      return new Date(parseInt(parts[0],10), parseInt(parts[1],10)-1, parseInt(parts[2],10));
    } else {
      return new Date(parseInt(parts[2],10), parseInt(parts[1],10)-1, parseInt(parts[0],10));
    }
  }

  function buildLockedCardInternal(tmDate, minDays, startWeek){
    function fmt(d){ var dd=('0'+d.getDate()).slice(-2), mm=('0'+(d.getMonth()+1)).slice(-2), yy=d.getFullYear(); return dd+'-'+mm+'-'+yy; }
    var targetText = '';
    if (tmDate) {
      var base = parseDateInternal(tmDate);
      if (base) {
        var target = new Date(base.getTime() + minDays*24*60*60*1000);
        var remain = Math.max(0, Math.ceil((target.getTime()-Date.now())/(1000*60*60*24)));
        targetText = remain > 0
          ? t('available_on', 'Available on __DATE__ (in __DAYS__ days)').replace('__DATE__', fmt(target)).replace('__DAYS__', remain)
          : t('available_on', 'Available on __DATE__').replace('__DATE__', fmt(target)).replace(' (in __DAYS__ days)', '');
      }
    } else {
      targetText = t('available_after_start', 'Available once your program has started');
    }
    return ''+
      '<div class="pp-locked-card">' +
        '<div class="pp-locked-body">'+
          '<div class="pp-locked-header">'+
            '<div class="pp-locked-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></div>'+
            '<div class="pp-locked-title">' + t('week_available_soon', 'Week __WEEK__ is available soon').replace('__WEEK__', startWeek||'') + '</div>'+
          '</div>'+
          '<div class="pp-locked-text">'+ targetText +'</div>'+
        '</div>'+
      '</div>';
  }

  // Expose for global use (needed by ppRecompute, initAddonInstance, ppShowModal outside IIFE)
  window.buildLockedCard = buildLockedCardInternal;
  window.parseDate = parseDateInternal;
  window.ppT = t;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Global HTML sanitizer for safe rendering of user content
function ppSanitizeHTML(html) {
  if (!html) return '';
  var temp = document.createElement('div');
  temp.innerHTML = html;
  var allowedTags = ['P', 'BR', 'STRONG', 'B', 'EM', 'I', 'U', 'UL', 'OL', 'LI', 'A', 'SPAN'];
  var walker = document.createTreeWalker(temp, NodeFilter.SHOW_ELEMENT, null, false);
  var nodesToRemove = [];
  while (walker.nextNode()) {
    var node = walker.currentNode;
    if (allowedTags.indexOf(node.tagName) === -1) {
      nodesToRemove.push(node);
    } else if (node.tagName === 'A') {
      var href = node.getAttribute('href') || '';
      if (!/^https?:\/\//.test(href) && !/^\//.test(href) && !/^#/.test(href)) {
        node.removeAttribute('href');
      }
      node.setAttribute('rel', 'noopener noreferrer');
    }
    var attrs = Array.prototype.slice.call(node.attributes);
    for (var i = 0; i < attrs.length; i++) {
      if (attrs[i].name.indexOf('on') === 0) {
        node.removeAttribute(attrs[i].name);
      }
    }
  }
  for (var j = 0; j < nodesToRemove.length; j++) {
    var n = nodesToRemove[j];
    var txt = document.createTextNode(n.textContent);
    n.parentNode.replaceChild(txt, n);
  }
  return temp.innerHTML;
}

// Global parseDate function - supports DD-MM-YYYY (localStorage) and YYYY-MM-DD (Shopify metafield)
function parseDate(dateStr) {
  if (!dateStr) return null;
  var parts = dateStr.split('-');
  if (parts.length !== 3) return null;
  if (parts[0].length === 4) {
    // YYYY-MM-DD (Shopify metafield format)
    return new Date(parseInt(parts[0],10), parseInt(parts[1],10)-1, parseInt(parts[2],10));
  } else {
    // DD-MM-YYYY (localStorage format)
    return new Date(parseInt(parts[2],10), parseInt(parts[1],10)-1, parseInt(parts[0],10));
  }
}

// Legacy global wrapper - delegates to internal version inside IIFE
function buildLockedCard(tmDate, minDays, startWeek){
  return window.buildLockedCard(tmDate, minDays, startWeek);
}

// Global recompute to ensure all blocks update instantly without refresh
function ppRecompute(mode){
  try { window.__ppLockedShown = false; } catch(_) {}
  var apps = document.querySelectorAll('.powerlifting-program__app');
  apps.forEach(function(root){
    var sw = Number(root.getAttribute('data-start-week')) || 1;
    var md = Number(root.getAttribute('data-min-days')) || 0;
    var cid = root.getAttribute('data-customer-id') || null;
    var output = root.querySelector('#pp-output') || root.querySelector('#pp-output-embed');
    var td = null;
    try { td = localStorage.getItem('pp_tm_date_' + (cid || 'guest')); } catch(_) {}
    if (!td) td = root.getAttribute('data-start-date') || null;

    if (mode === 'reset') {
      if (sw === 1) {
        // show controls and start prompt
        var ctrls = root.querySelectorAll('.powerlifting-program__controls');
        ctrls.forEach(function(el){ el.style.display = ''; });
        if (output) output.innerHTML = '<div class=”pp-output-note”>' + (window.ppT || function(k,f){return f;})(  'start_prompt', 'Start your program: select your 1RM bench press (kg).') + '</div>';
        root.style.display = '';
      } else {
        // hide later blocks entirely
        var ctrls2 = root.querySelectorAll('.powerlifting-program__controls');
        ctrls2.forEach(function(el){ el.style.display = 'none'; });
        if (output) output.innerHTML = '';
        root.style.display = 'none';
      }
      return;
    }

    if (mode === 'started') {
      if (md > 0) {
        if (!td) { root.style.display = 'none'; return; }
        var allow = false;
        var d0 = parseDate(td);
        if (d0) {
          var diff = Math.floor((Date.now() - d0.getTime())/(1000*60*60*24));
          if (diff >= md) allow = true;
        }
        if (!allow) {
          root.querySelectorAll('.powerlifting-program__controls').forEach(function(el){ el.style.display = 'none'; });
          if (!window.__ppLockedShown && output) {
            window.__ppLockedShown = true; output.innerHTML = buildLockedCard(td, md, sw); root.style.display = ''; return; }
          root.style.display = 'none'; return;
        } else {
          root.style.display = '';
        }
      } else {
        root.style.display = '';
      }
    }
  });
}

// Note: Individual instances now have their own event listeners registered at the start of initInstance()
// ppRecompute is kept for backwards compatibility but events are handled per-instance

// Initialize add-on instances (pure gating and locked message)
function initAddonInstance(root){
  if (root.getAttribute('data-pp-addon-init') === 'true') return;
  root.setAttribute('data-pp-addon-init','true');

  // Find the title element in the parent section
  var sectionTitle = null;
  var parent = root.closest('.powerlifting-addon__inner');
  if (parent) sectionTitle = parent.querySelector('.powerlifting-program__title');

  function evaluate(mode){
    var sw = Number(root.getAttribute('data-start-week')) || 1;
    var md = Number(root.getAttribute('data-min-days')) || 0;
    var cid = root.getAttribute('data-customer-id') || null;
    var output = root.querySelector('.pp-addon-output');
    var td = null; try { td = localStorage.getItem('pp_tm_date_' + (cid || 'guest')); } catch(_) {}
    if (!td) td = root.getAttribute('data-start-date') || null;

    // Handle reset mode - always hide add-ons on reset
    if (mode === 'reset') {
      root.style.display = 'none';
      if (sectionTitle) sectionTitle.style.display = 'none';
      return;
    }

    // When not logged in and not first block, hide entire section including title
    if (!cid && sw !== 1) {
      root.style.display = 'none';
      if (sectionTitle) sectionTitle.style.display = 'none';
      return;
    }

    // ALWAYS require a start date - hide if schema not started yet
    if (!td) {
      root.style.display = 'none';
      if (sectionTitle) sectionTitle.style.display = 'none';
      return;
    }

    // Check minDays gating if applicable
    if (md > 0) {
      var allow = false;
      var d0 = parseDate(td);
      if (d0) {
        var diff = Math.floor((Date.now()-d0.getTime())/(1000*60*60*24));
        if (diff >= md) allow = true;
      }
      if (!allow) {
        if (!window.__ppLockedShown && output) {
          window.__ppLockedShown = true;
          output.innerHTML = buildLockedCard(td, md, sw);
          root.style.display = '';
          if (sectionTitle) sectionTitle.style.display = 'none';
        }
        else {
          root.style.display = 'none';
          if (sectionTitle) sectionTitle.style.display = 'none';
        }
        return;
      }
    }

    // Schema is started and gating passed - show the add-on
    root.style.display = '';
    if (sectionTitle) sectionTitle.style.display = '';
  }
  evaluate();
  window.addEventListener('pp:reset', function(){ evaluate('reset'); });
  window.addEventListener('pp:started', function(){ evaluate('started'); });

  // Note modal handler
  root.addEventListener('click', function(e){
    var b = e.target.closest('.pp-note-more');
    if (!b) return;
    e.preventDefault();
    var html = b.getAttribute('data-note-html') || '';
    var title = b.getAttribute('data-note-title') || 'Info';
    ppShowModal(title, html);
  });

  // Lock overlay: click to unlock product card (both desktop & mobile)
  root.addEventListener('click', function(e){
    var r = e.target.closest('.pp-lock-overlay');
    if (!r) return;
    e.preventDefault();
    var item = r.closest('.pp-addon-item--product');
    if (item) item.classList.add('is-unlocked');
  });
}

// Shared simple modal for notes
function ppShowModal(title, html){
  var _t = window.ppT || function(k,f){return f;};
  var id = 'pp-info-modal';
  var el = document.getElementById(id);
  if (!el) {
    el = document.createElement('div');
    el.id = id; el.className = 'pp-modal hidden';
    el.innerHTML = '<div class="pp-modal__backdrop"></div>'+
                   '<div class="pp-modal__dialog cn-table">'+
                     '<div class="gold-frame">'+
                       '<div class="card_samenstelling">'+
                         '<div class="pp-modal__header">'+
                           '<div class="pp-modal__title"></div>'+
                           '<button class="pp-modal__close" aria-label="' + _t('close', 'Close') + '">×</button>'+
                         '</div>'+
                         '<div class="pp-modal__content"></div>'+
                       '</div>'+
                     '</div>'+
                   '</div>';
    document.body.appendChild(el);
    el.querySelector('.pp-modal__backdrop').addEventListener('click', hide);
    el.querySelector('.pp-modal__close').addEventListener('click', hide);
  }
  function hide(){ el.classList.add('hidden'); document.body.classList.remove('pp-modal-open'); }
  el.querySelector('.pp-modal__title').textContent = title;
  el.querySelector('.pp-modal__content').innerHTML = ppSanitizeHTML(html);
  el.classList.remove('hidden');
  document.body.classList.add('pp-modal-open');
}

// Sync customer data to n8n webhook for metafield updates
// eventType: 'Created' (new schema) or 'Reset' (schema reset)
// Includes retry logic with exponential backoff
function saveCustomerTM(eventType, email, tm, dateStr) {
  if (!email) return; // Only sync for logged-in customers

  var webhookUrl = 'https://cnsupplements.app.n8n.cloud/webhook/3c3eebce-5f41-4e67-8bd2-10afd67143ab';
  var maxRetries = 3;
  var baseDelay = 1000; // 1 second

  function attemptSync(retryCount) {
    var payload = {
      event: eventType,
      customer_email: email,
      bench_one_rep_max: tm,
      date: dateStr,
      retry_attempt: retryCount
    };

    fetch(webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }
      if (retryCount > 0) {
        console.log('Bench Booster sync succeeded after ' + retryCount + ' retries');
      }
    })
    .catch(function(err) {
      if (retryCount < maxRetries) {
        var delay = baseDelay * Math.pow(2, retryCount); // Exponential backoff: 1s, 2s, 4s
        console.warn('Bench Booster sync failed, retrying in ' + (delay/1000) + 's...', err.message);
        setTimeout(function() {
          attemptSync(retryCount + 1);
        }, delay);
      } else {
        console.error('Bench Booster sync failed after ' + maxRetries + ' retries:', err.message);
        // Store failed sync for potential manual retry later
        try {
          var pendingKey = 'pp_pending_sync';
          var pending = JSON.parse(localStorage.getItem(pendingKey) || '[]');
          pending.push({ event: eventType, email: email, tm: tm, date: dateStr, timestamp: Date.now() });
          // Keep only last 5 pending syncs to avoid storage bloat
          if (pending.length > 5) pending = pending.slice(-5);
          localStorage.setItem(pendingKey, JSON.stringify(pending));
        } catch(e) { /* localStorage not available */ }
      }
    });
  }

  try {
    attemptSync(0);
  } catch(e) {
    console.error('Bench Booster sync error:', e);
  }
}
